import { jsx as C } from "react/jsx-runtime";
function r(t) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ C("path", { d: "M19 18C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20H1C0.447715 20 0 19.5523 0 19C0 18.4477 0.447715 18 1 18H19ZM9.33691 3.8623C9.70253 3.68222 10.1235 3.65989 10.5029 3.79492L10.6631 3.8623L10.793 3.93652C11.0768 4.12045 11.2352 4.38077 11.3174 4.52539C11.4229 4.71113 11.5312 4.9521 11.6387 5.18848L15.9102 14.5859C16.1386 15.0886 15.9166 15.6815 15.4141 15.9102C14.9428 16.1244 14.392 15.9427 14.1367 15.5049L14.0898 15.4141L12.5381 12H7.46191L5.91016 15.4141C5.68152 15.9166 5.08862 16.1386 4.58594 15.9102C4.08336 15.6815 3.86135 15.0886 4.08984 14.5859L8.36133 5.18848C8.46877 4.9521 8.57712 4.71113 8.68262 4.52539C8.77656 4.36003 8.97006 4.04304 9.33691 3.8623ZM8.37109 10H11.6289L10 6.41504L8.37109 10ZM19 0C19.5523 0 20 0.447715 20 1C20 1.55228 19.5523 2 19 2H1C0.447715 2 0 1.55228 0 1C0 0.447715 0.447715 0 1 0H19Z" })
    }
  );
}
export {
  r as default
};
